import { withStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';

const BlackCard = withStyles({
  root: {
    border: '1px solid #cb0000',
  },
})(Card);

export default BlackCard;